
import { useContext, useEffect, useState } from 'react'
import interfone from '../../Assets/icones/interfone.svg'
import Entrada from '../../Components/Entrada/Entrada'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'

const ListaEntradas = ({ callbackAbrirPorta, isDisabled = false }) => {
    const { activeCond } = useContext(CondominiosContext)
    const [Entradas, setEntradas] = useState([])
    const { addRoute, sendWs } = useContext(WebSocketContext)

    useEffect(() => {
        addRoute("listaEntradas", (msg) => {
            let entradas = msg.data.listaEntradas
            setEntradas(entradas)
        })
        sendWs("listaEntradas", { id_central: activeCond.id_central })
    }, [activeCond])

    return (
        <>
            {
                Entradas.map((entrada, index) => {
                    return (<Entrada
                        key={index}
                        IconStart={interfone}
                        nomeEntrada={entrada.descricao}
                        objEntrada={entrada}
                        id_Central={activeCond.id_central}
                        callbackAbrirPorta={callbackAbrirPorta}
                        isDisabled={isDisabled}
                    >
                    </Entrada>)
                })
            }
        </>
    )
}

export default ListaEntradas
